import { Collapse, Space, Typography } from "antd"
import { useContext } from "react"
import EditVisitContext from "./EditVisitContext"
import { useVisitQuery, useJobQuery } from "./apiQueries"
import { getJobId } from "./editVisitModel"
import WorkareaItems from "./WorkareaItems"
import { enrichWorkareaItems } from "./item"
import WorkareaLabel from './WorkareaLabel'

const { Title } = Typography

const ItemsSection = () => {
  const data = useContext(EditVisitContext)
  const visitQuery = useVisitQuery(data.visitId)
  const jobId = getJobId(data, visitQuery.data)
  const jobQuery = useJobQuery(jobId, data.visitId)
  const enriched = jobQuery.data ? enrichWorkareaItems(jobQuery.data, data.itemChanges) : []

  const findEnriched = (workareaId: number) => enriched.find(x => x.workareaId === workareaId) || { workareaId, items: [] }
  const workareas = jobQuery.data?.workareas ?? []

  const collapsePanels = workareas?.map(x => (
    {
      key: `panel-${x.id}`,
      label: <WorkareaLabel workarea={x} />,
      children: <WorkareaItems workareaId={x.id} items={findEnriched(x.id).items} />
    }
  ))

  return <Space direction="vertical" style={{ width: '100%' }}>
    <Title level={5}>Items</Title>
    <Collapse items={collapsePanels} />
  </Space>
}
export default ItemsSection
